import React, { useState } from 'react';
import { X } from 'lucide-react';
import axios from 'axios';

const CandidatoModal = ({ isOpen, onClose, onRefresh, procesos = [] }) => {
  const [formData, setFormData] = useState({
    nombre: '',
    email: '',
    telefono: '',
    etapa_actual: 'Nuevos Postulantes',
    rating: 0,
    procesoId: procesos.length > 0 ? procesos[0].id : ''
  });

  const [file, setFile] = useState(null);

  if (!isOpen) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // 1. Crear el candidato
      const response = await axios.post('http://localhost:5000/api/candidatos', formData);
      const nuevoCandidato = response.data;

      // 2. Si hay un archivo, subirlo asociado al ID del nuevo candidato
      if (file && nuevoCandidato.id) {
        const uploadData = new FormData();
        uploadData.append('cv', file);
        await axios.post(`http://localhost:5000/api/candidatos/${nuevoCandidato.id}/upload-cv`, uploadData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });
      }

      onRefresh(); // Refresca la lista en el dashboard
      onClose();   // Cierra el modal
      setFile(null); // Resetear el archivo
    } catch (error) {
      console.error("Error al guardar:", error);
    }
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg w-[500px] shadow-xl">
        <div className="p-4 border-b flex justify-between items-center bg-gray-50 rounded-t-lg">
          <h2 className="font-bold text-gray-700 uppercase text-sm">Agregar Nuevo Candidato</h2>
          <X className="cursor-pointer text-gray-400 hover:text-gray-600" onClick={onClose} />
        </div>
        
        <form onSubmit={handleSubmit} className="p-6 space-y-4">
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Nombre Completo</label>
            <input 
              type="text" required className="w-full border rounded p-2 text-sm outline-emeral-green"
              onChange={(e) => setFormData({...formData, nombre: e.target.value})}
            />
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Email</label>
            <input 
              type="email" required className="w-full border rounded p-2 text-sm outline-emeral-green"
              onChange={(e) => setFormData({...formData, email: e.target.value})}
            />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Teléfono</label>
              <input 
                type="text" className="w-full border rounded p-2 text-sm outline-emeral-green"
                onChange={(e) => setFormData({...formData, telefono: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Etapa Inicial</label>
              <select 
                className="w-full border rounded p-2 text-sm outline-emeral-green bg-white"
                onChange={(e) => setFormData({...formData, etapa_actual: e.target.value})}
              >
                <option>Nuevos Postulantes</option>
                <option>Posibles</option>
                <option>Entrevista Psicologica</option>
              </select>
            </div>
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Asignar a Proceso</label>
            <select 
              required
              className="w-full border rounded p-2 text-sm outline-emeral-green bg-white"
              onChange={(e) => setFormData({...formData, procesoId: e.target.value})}
              value={formData.procesoId}
            >
              <option value="" disabled>Selecciona un proceso...</option>
              {procesos.map(proc => (
                <option key={proc.id} value={proc.id}>{proc.titulo}</option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-xs font-bold text-gray-500 uppercase mb-1">Curriculum Vitae (PDF)</label>
            <input 
              type="file" 
              accept="application/pdf"
              className="w-full border rounded p-2 text-sm outline-emeral-green"
              onChange={(e) => setFile(e.target.files[0])}
            />
          </div>
          
          <div className="pt-4 flex justify-end gap-2">
            <button type="button" onClick={onClose} className="px-4 py-2 text-xs font-bold text-gray-400 uppercase">Cancelar</button>
            <button type="submit" className="bg-emeral-green text-white px-6 py-2 rounded text-xs font-bold uppercase hover:bg-opacity-90">
              Guardar Candidato
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CandidatoModal;